// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Card,
  CardContent,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip
} from '@material-ui/core';

import {
  _setActiveTab,
  _setPatientDrawerPatientDetails
} from '@shared/store/actions/PatientDrawerAction';
import {
  AppPermissions,
  BenefitNetworkChipColor,
  EligibilityStatusMappingObj,
  PatientsTabKeys,
  USER,
  networkKeyTranslationMapper
} from '@shared/constants/Mapping';

import React, {useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './PatientDetailsSidebar.scss';
import ClipboardIcon from '@components/system/MyIcons/ClipboardIcon';
import CardPosIcon from '@components/system/MyIcons/CardPosIcon';
import CalendarTickIcon from '@components/system/MyIcons/CalendarTickIcon';
import MessagesIconNew from '@components/system/MyIcons/MessagesIconNew';
import CallIncomingIcon from '@components/system/MyIcons/CallIncomingIcon';
import ProfileLinearIcon from '@components/system/MyIcons/ProfileLinearIcon';
import ProfileBulkIcon from '@components/system/MyIcons/ProfileBulkIcon';
import {Permission} from '@shared/services/PermissionService';
import {useTranslation} from 'react-i18next';
import Timer from '../../../ChronicCareManagement/module-components/TimeTracker/Timer';
// import CCMEnrollmentDialog from '../../../ChronicCareManagement/module-components/EnrollCCMDialog/CCMDialog/CCMEnrollmentDialog';
import HelperUtils from '@shared/utils/HelperUtils';
import AddCcmTimeDialog from '../../../ChronicCareManagement/module-components/addCcmTimeDialog/AddCcmTimeDialog';
import MedicalInsuranceIcon from '@components/system/MyIcons/MedicalInsuranceIcon';
import PriorAuthIcon from '@components/system/MyIcons/PriorAuthIcon';
import ReferralIcon from '@components/system/MyIcons/ReferralIcon';

import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';
import {getClinicGroupsDetails} from '@shared/services/ClinicServices';
import {State} from '@shared/store/reducers/Index';
import CCMIcon from '@components/system/MyIcons/CCMIcon';
import {APP} from 'src/style/variable';
import ClaimIcon from '@components/system/MyIcons/ClaimIcon';
import useClaimsTicketsPermissions from '../../../ClaimsTickets/hooks/useClaimsTicketsPermissions';
import usePriorAuthPermission from '../../../PriorAuthorization/hooks/usePriorAuthPermission';
import PharmacyClaimIcon from '@components/system/MyIcons/PharmacyClaimIcon';
import useReferralsTicketsPermissions from '../../../ReferralsTickets/hooks/useReferralsTicketsPermission';
import EligibilityVerificationIcon from '@components/system/MyIcons/EligibilityVerificationIcon';
import CCMPatientProblemsDrawer from '../../../ChronicCareManagement/module-components/CCMPatients/CCMActiveProblems/CCMPatientProblemsDrawer';
import {
  archiveCCMPatient,
  unarchiveCCMPatient,
  resetCCMTimerService,
  markAsComplexCCMPatient,
  removeComplexCCMPatient
} from '@shared/services/CCMServices';

interface PatientDetailsSidebarProps {
  onNavItemClick?: () => void;
  closeDrawer: () => void;
}

const PatientDetailsSideBar = ({
  onNavItemClick,
  closeDrawer
}: PatientDetailsSidebarProps): JSX.Element => {
  const dispatch = useDispatch();
  // FIXME: ADD PROPER TYPES
  const {
    activeTab,
    patientDetails: selectedPatient,
    eligibilityVerificationAppointment: appointment,
    eligibilityNetwork
  } = useSelector((state: any) => state.patientDetailsDrawer);
  const {userType, userPermissions} = useSelector((state: State) => state.auth);
  const timerInfo: any = useSelector((state: State) => state.ccmTimer);

  const groupId = useSelector((state: any) => state.auth.groupId);

  const {t} = useTranslation();

  const {enqueueSnackbar} = useSnackbar();

  const [groupDetails, setGroupDetails]: any = useState({});

  const clinicId = useSelector(
    (state: any) => state.patientDetailsDrawer.clinicId
  );

  const [stateShowDialog, setStateShowDialog] = useState({
    ccmDialogOpen: false,
    openAddCcmTimeDialog: false
  });
  const {ccmDialogOpen, openAddCcmTimeDialog} = stateShowDialog;

  const patientFullName = `${selectedPatient['first_name'] ?? ''} ${
    selectedPatient['middle_name'] ?? ''
  } ${selectedPatient['last_name'] ?? ''}`;

  const clinicsList: any = useSelector(
    (state: any) => state.clinics.list || []
  );

  // Eligibility verification is enabled at group level and insurance provider is set for the practice
  const isEligibilityVerificationEnabled = useMemo(() => {
    const isUserInsuranceRolePermissionExists =
      userType === USER.ADMIN ||
      Permission.hasEligibilityVerificationPermissions(
        userPermissions,
        AppPermissions.ELIGIBILITY_VERIFICATION?.READ,
        groupId
      );
    if (!isUserInsuranceRolePermissionExists) return false;

    const eligibilityEnabled =
      groupDetails[AppPermissions.MENU_PERMISSIONS.ELIGIBILITY_VERIFICATION];
    if (!eligibilityEnabled) return false;
    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupId
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }
    if (Array.isArray(clinicsList)) {
      const clinicDetails = clinicsList.find((cl: any) => cl?.id === clinicId);
      return !!clinicDetails?.insurance_config?.insurance_provider;
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupDetails, clinicsList, clinicId]);

  const hasCCMPermission = useMemo(() => {
    // USER DOESN'T HAVE CCM PERMISSION
    if (
      !Permission.hasCCMPermissions(
        userPermissions,
        AppPermissions.CCM.LIST,
        groupId
      )
    ) {
      return false;
    }

    // IF PATIENT SHARED IS ON THEN CCM MUST BE ENABLED AT GROUP
    if (
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.PATIENT_MENU_PERMISSIONS.PATIENT_SHARED
      ] === true &&
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.CCM_MENU_PERMISSIONS.CCM
      ] === true
    ) {
      return true;
    }

    const hasClinicListBeenUpdated = clinicsList.some(
      (cl: any) => cl.org_group_id === groupId
    );
    if (!hasClinicListBeenUpdated) {
      return false;
    }

    if (
      userPermissions?.[groupId]?.['group']?.[
        AppPermissions.PATIENT_MENU_PERMISSIONS.PATIENT_SHARED
      ] === false
    ) {
      if (clinicId) {
        const selectedClinic = clinicsList.find((c: any) => c.id === clinicId);
        if (selectedClinic && selectedClinic.is_ccm_enabled === true) {
          return true;
        }
        return false;
      }
      return false;
    }
    return false;
  }, [userPermissions, groupId, clinicId, clinicsList]);

  const hasPriorAuthPermission = usePriorAuthPermission();

  const hasClaimsTicketsPermission = useClaimsTicketsPermissions();

  const hasReferralsTicketsPermission = useReferralsTicketsPermissions();

  const pharmacyClaimsEnabled: boolean =
    userPermissions?.[groupId]?.['group']?.[
      AppPermissions.MENU_PERMISSIONS.PHARMACY_CLAIMS_ENABLE
    ];

  const patientDrawerTabsWithPermission = useMemo(() => {
    const patientDrawerTabs = [
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.PATIENT_DETAILS}`),
        hasPermission: true,
        icon: ProfileLinearIcon,
        key: PatientsTabKeys.PATIENT_DETAILS
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.STATEMENTS}`),
        hasPermission: Permission.hasStatementPermissions(
          userPermissions,
          AppPermissions.STATEMENT.LIST,
          groupId
        ),
        icon: ClipboardIcon,
        key: PatientsTabKeys.STATEMENTS
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.PAYMENTS}`),
        hasPermission: Permission.hasPaymentHistoryPermissions(
          userPermissions,
          AppPermissions.PAYMENT_HISTORY.LIST,
          groupId
        ),
        icon: CardPosIcon,
        key: PatientsTabKeys.PAYMENTS
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.MESSAGES}`),
        hasPermission: Permission.hasIncomingSmsPermissions(
          userPermissions,
          AppPermissions.INCOMING_SMS.LIST,
          groupId
        ),
        icon: MessagesIconNew,
        key: PatientsTabKeys.MESSAGES
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.APPOINTMENTS}`),
        hasPermission: Permission.hasAppointmentPermissions(
          userPermissions,
          AppPermissions.APPOINTMENT.LIST,
          groupId
        ),
        icon: CalendarTickIcon,
        key: PatientsTabKeys.APPOINTMENTS
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.RECALL_ANALYSIS}`),
        hasPermission:
          Permission.hasPatientRecallPermissions(
            userPermissions,
            AppPermissions.PATIENT_RECALL.LIST,
            groupId
          ) &&
          !!userPermissions?.[groupId]?.['group']?.[
            AppPermissions.MENU_PERMISSIONS.PATIENT_RECALL
          ],
        icon: CallIncomingIcon,
        key: PatientsTabKeys.RECALL_ANALYSIS
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.INSURANCE}`),
        hasPermission: true,
        key: PatientsTabKeys.INSURANCE,
        icon: MedicalInsuranceIcon
      },
      {
        label: t(
          `PATIENT_DETAILS_DRAWER.${PatientsTabKeys.ELIGIBILITY_VERIFICATION}`
        ),
        hasPermission: isEligibilityVerificationEnabled,
        key: PatientsTabKeys.ELIGIBILITY_VERIFICATION,
        icon: EligibilityVerificationIcon
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.CCM}`),
        hasPermission:
          hasCCMPermission && selectedPatient?.ccm_patient_archived !== true,
        icon: CCMIcon,
        key: PatientsTabKeys.CCM
      },
      {
        label: t(
          `PATIENT_DETAILS_DRAWER.${PatientsTabKeys.PRIOR_AUTHORIZATION}`
        ),
        hasPermission: hasPriorAuthPermission,
        key: PatientsTabKeys.PRIOR_AUTHORIZATION,
        icon: PriorAuthIcon
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.CLAIMS_TICKETS}`),
        hasPermission: hasClaimsTicketsPermission,
        key: PatientsTabKeys.CLAIMS_TICKETS,
        icon: ClaimIcon
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.REFERRALS_TICKETS}`),
        hasPermission: hasReferralsTicketsPermission,
        key: PatientsTabKeys.REFERRALS_TICKETS,
        icon: ReferralIcon
      },
      {
        label: t(`PATIENT_DETAILS_DRAWER.${PatientsTabKeys.PHARMACY_CLAIMS}`),
        hasPermission: pharmacyClaimsEnabled,
        key: PatientsTabKeys.PHARMACY_CLAIMS,
        icon: PharmacyClaimIcon
      }
    ];
    return patientDrawerTabs.filter(tab => tab.hasPermission);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userPermissions,
    groupId,
    hasCCMPermission,
    isEligibilityVerificationEnabled,
    hasPriorAuthPermission,
    selectedPatient?.ccm_patient_archived
  ]);

  const closeCcmEnrollDialog = () => {
    setStateShowDialog((prevState: any) => ({
      ...prevState,
      ccmDialogOpen: false
    }));
  };
  const openCcmEnrollDialog = (row: any) => {
    setStateShowDialog((prevState: any) => ({
      ...prevState,
      ccmDialogOpen: true,
      patientName: patientFullName,
      accountNumber: row.account_number,
      clinicId: row.clinic_id,
      patientId: row.patient_id
    }));
  };

  // Show Add Time CCM

  const showCcmTimeDialog = (row: any) => {
    setStateShowDialog(prevState => ({
      ...prevState,
      openAddCcmTimeDialog: true,
      patientName: HelperUtils.commaSeparatedFullName(
        row.first_name,
        row.last_name,
        row.middle_name
      ),
      accountNumber: row.account_number,
      clinicId: row.clinic_id,
      patientId: row.patient_id,
      ccmPatientId: row.ccm_patient_id
    }));
  };

  const closeCcmTimeDialog = () => {
    setStateShowDialog(prevState => ({
      ...prevState,
      openAddCcmTimeDialog: false
    }));
  };

  const archiveCCM = async (patientDetail: any) => {
    try {
      const queryParams: {clinic_id?: string | number} = {};
      if (clinicId) {
        queryParams.clinic_id = clinicId;
      }
      const response = await archiveCCMPatient(
        groupId,
        patientDetail?.ccm_patient_id,
        queryParams
      );
      if (response) {
        enqueueSnackbar(
          response?.message || t('CCM.CCM_PATIENT_ARCHIVED'),
          SnackBarConfig('s')
        );
        dispatch(
          _setPatientDrawerPatientDetails(
            groupId,
            clinicId,
            selectedPatient?.patient_id
          )
        );
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const markAsComplexCCM = async ({ccmPatientId}: {ccmPatientId: number}) => {
    try {
      const response = await markAsComplexCCMPatient(
        groupId,
        ccmPatientId,
        clinicId
      );
      if (response) {
        enqueueSnackbar(
          response?.message || t('CCM.CCM_PATIENT_MARKED_AS_COMPLEX'),
          SnackBarConfig('s')
        );
        dispatch(
          _setPatientDrawerPatientDetails(
            groupId,
            clinicId,
            selectedPatient?.patient_id
          )
        );
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const removeComplexCCM = async ({ccmPatientId}: {ccmPatientId: number}) => {
    try {
      const response = await removeComplexCCMPatient(
        groupId,
        ccmPatientId,
        clinicId
      );
      if (response) {
        enqueueSnackbar(
          response?.message || t('CCM.CCM_PATIENT_REMOVED_FROM_COMPLEX'),
          SnackBarConfig('s')
        );
        dispatch(
          _setPatientDrawerPatientDetails(
            groupId,
            clinicId,
            selectedPatient?.patient_id
          )
        );
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const resetCCMTimer = async ({ccmPatientId}: {ccmPatientId: number}) => {
    try {
      const response = await resetCCMTimerService(
        groupId,
        ccmPatientId,
        clinicId
      );
      if (response) {
        enqueueSnackbar(
          response?.message || t('CCM.CCM_TIMER_RESET'),
          SnackBarConfig('s')
        );
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  const unarchiveCCM = async (patientDetail: any) => {
    try {
      const queryParams: {clinic_id?: string | number} = {};
      if (clinicId) {
        queryParams.clinic_id = clinicId;
      }
      const response = await unarchiveCCMPatient(
        groupId,
        patientDetail?.ccm_patient_id,
        queryParams
      );
      if (response) {
        enqueueSnackbar(
          response?.message || t('CCM.CCM_PATIENT_UNARCHIVED'),
          SnackBarConfig('s')
        );
        dispatch(
          _setPatientDrawerPatientDetails(
            groupId,
            clinicId,
            selectedPatient?.patient_id
          )
        );
      }
    } catch (err: any) {
      enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      throw err;
    }
  };

  // showing link i.e., Enroll for CCM in Actions column in Patients
  const renderEnrollForCCM = (patientDetail: any) => {
    // If patient is archived, show unarchive option instead
    if (patientDetail?.ccm_patient_archived === true) {
      return (
        <Tooltip
          title={
            t('PATIENT_DETAILS_DRAWER.CCM_MODULE.UNARCHIVE_CCM') ||
            'Unarchive CCM'
          }>
          <Link
            component="button"
            style={{
              textAlign: 'right',
              whiteSpace: 'nowrap',
              marginBottom: '0.5rem'
            }}
            variant="body2"
            onClick={(e: any): void => {
              unarchiveCCM(patientDetail);
              e.stopPropagation();
            }}>
            {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.UNARCHIVE_CCM')}
          </Link>
        </Tooltip>
      );
    }
    return (
      <Tooltip title={t('PATIENTS.ENROLL_FOR_CCM', {}) as string}>
        <Link
          component="button"
          style={{
            textAlign: 'right',
            whiteSpace: 'nowrap',
            marginBottom: '0.5rem'
          }}
          variant="body2"
          onClick={(e: any): void => {
            openCcmEnrollDialog(patientDetail);
            e.stopPropagation();
          }}>
          {t('CCM.ENROLL_FOR_CCM')}
        </Link>
      </Tooltip>
    );
  };

  const getSelectedGroupDetails = async (id: any): Promise<void> => {
    try {
      getClinicGroupsDetails(id)
        .then((clinicGroupDetails: any) => {
          if (clinicGroupDetails?.data) {
            setGroupDetails(clinicGroupDetails.data);
          }
        })
        .catch(error => {
          enqueueSnackbar(
            t('CLINICS.CLINIC_GROUP_DETAILS_ERROR'),
            SnackBarConfig('e')
          );
          throw error;
        });
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_DETAILS_ERROR'),
        SnackBarConfig('e')
      );
      throw error;
    }
  };

  const init = async () => {
    await getSelectedGroupDetails(groupId);
  };
  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const isTimeRunningForCurrentPatient =
    timerInfo.isTimerRunning &&
    timerInfo.ccmPatientId == selectedPatient?.ccm_patient_id;
  return (
    <div className={'patient-sidebar-wrapper'}>
      {/* Patient Info */}
      <Card className="patient-info-wrapper">
        <CardContent className="patient-content">
          {/* Complex CCM  */}
          {selectedPatient?.ccm_patient_mark_as_complex && (
            <div className="complex-ccm-tag">
              {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.COMPLEX_CCM')}
            </div>
          )}
          <div className="patient-avatar-wrapper">
            <ProfileBulkIcon className="patient-avatar" />
          </div>
          <div className="patient-details">
            <p className="name">{patientFullName}</p>
          </div>

          <div>
            {hasCCMPermission &&
              (selectedPatient.ccm_patient_id ? (
                <>
                  {selectedPatient?.ccm_patient_archived !== true && (
                    <>
                      <div style={{marginBottom: '0.5rem'}}>
                        <Timer
                          groupId={groupId}
                          clinicId={clinicId}
                          patientId={selectedPatient?.patient_id}
                          ccmPatientId={selectedPatient?.ccm_patient_id}
                          guarantorId={selectedPatient?.guarantor_id}
                          isPlanActive={selectedPatient?.is_plan_active}
                          isExternalPlanActive={
                            selectedPatient?.is_external_care_plan
                          }
                          patientName={patientFullName}
                          patientAccountNumber={
                            selectedPatient?.patient_account_number
                          }
                          guarantorNotificationPhone={
                            selectedPatient?.guarantor_notification_phone
                          }
                          startTimerLabel={t('CCM.START_TIMER.CCM_START_TIMER')}
                          isFromPatientDrawer
                        />
                      </div>
                      <div className="patient-details">
                        <Tooltip title={t('CCM.ADD_TIME.ADD_TIME') as string}>
                          <div
                            style={{
                              opacity: isTimeRunningForCurrentPatient ? 0.5 : 1,
                              textDecoration: isTimeRunningForCurrentPatient
                                ? 'none'
                                : ''
                            }}
                            className="link-text-style"
                            onClick={(e: any) => {
                              if (isTimeRunningForCurrentPatient) {
                                return;
                              }
                              showCcmTimeDialog(selectedPatient);
                              e.stopPropagation();
                            }}>
                            {t('CCM.ADD_TIME.ADD_TIME')}
                          </div>
                        </Tooltip>
                        {selectedPatient?.ccm_patient_archived === false && (
                          <Tooltip
                            title={
                              t(
                                'PATIENT_DETAILS_DRAWER.CCM_MODULE.ARCHIVE_CCM'
                              ) || 'Archive CCM'
                            }>
                            <div
                              className="link-text-style"
                              onClick={(e: any) => {
                                archiveCCM(selectedPatient);
                                e.stopPropagation();
                              }}>
                              {t(
                                'PATIENT_DETAILS_DRAWER.CCM_MODULE.ARCHIVE_CCM'
                              )}
                            </div>
                          </Tooltip>
                        )}
                        {selectedPatient?.is_timer_running && (
                          <Tooltip
                            title={t('CCM.RESET_TIMER.RESET_TIMER') as string}>
                            <div
                              className="link-text-style"
                              onClick={(e: any) => {
                                resetCCMTimer({
                                  ccmPatientId: selectedPatient?.ccm_patient_id
                                });
                                e.stopPropagation();
                              }}>
                              {t('CCM.RESET_TIMER.RESET_TIMER')}
                            </div>
                          </Tooltip>
                        )}
                        {selectedPatient?.ccm_patient_mark_as_complex ===
                        false ? (
                          <Tooltip
                            title={t(
                              'PATIENT_DETAILS_DRAWER.CCM_MODULE.MARK_AS_COMPLEX_CCM'
                            )}>
                            <div
                              className="link-text-style"
                              onClick={(e: any) => {
                                markAsComplexCCM({
                                  ccmPatientId: selectedPatient?.ccm_patient_id
                                });
                                e.stopPropagation();
                              }}>
                              {t(
                                'PATIENT_DETAILS_DRAWER.CCM_MODULE.MARK_AS_COMPLEX_CCM'
                              )}
                            </div>
                          </Tooltip>
                        ) : (
                          <Tooltip
                            title={t(
                              'PATIENT_DETAILS_DRAWER.CCM_MODULE.REMOVE_COMPLEX_CCM'
                            )}>
                            <div
                              className="link-text-style"
                              onClick={(e: any) => {
                                removeComplexCCM({
                                  ccmPatientId: selectedPatient?.ccm_patient_id
                                });
                                e.stopPropagation();
                              }}>
                              {t(
                                'PATIENT_DETAILS_DRAWER.CCM_MODULE.REMOVE_COMPLEX_CCM'
                              )}
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    </>
                  )}
                  {selectedPatient?.ccm_patient_archived === true && (
                    <div className="patient-details">
                      <Tooltip
                        title={
                          t(
                            'PATIENT_DETAILS_DRAWER.CCM_MODULE.UNARCHIVE_CCM'
                          ) || 'Unarchive CCM'
                        }>
                        <div
                          className="link-text-style"
                          onClick={(e: any) => {
                            unarchiveCCM(selectedPatient);
                            e.stopPropagation();
                          }}>
                          {t('PATIENT_DETAILS_DRAWER.CCM_MODULE.UNARCHIVE_CCM')}
                        </div>
                      </Tooltip>
                    </div>
                  )}
                </>
              ) : (
                renderEnrollForCCM(selectedPatient)
              ))}
          </div>
        </CardContent>
      </Card>

      {/* Navigation Tabs*/}
      <List className="sidebar-tab-list">
        {patientDrawerTabsWithPermission.map(item => {
          const ItemIcon = item.icon;
          return (
            <ListItem
              className={[
                activeTab === item.key ? 'tab--active' : '',
                'tab'
              ].join(' ')}
              button
              component={'li'}
              onClick={() => {
                dispatch(_setActiveTab(item.key));

                // It is to close the sidebar on mobile screen when users click on any item
                if (onNavItemClick) {
                  onNavItemClick();
                }
              }}
              key={item.key}>
              {activeTab === item.key && <div className={'decor_line'} />}
              <ListItemIcon className={'tab-icon-wrapper'}>
                <ItemIcon className={'tab-icon'} />
              </ListItemIcon>
              <ListItemText
                className={'tab-text'}
                primary={
                  <div>
                    <p>{item.label}</p>
                    {item.key === PatientsTabKeys.ELIGIBILITY_VERIFICATION &&
                      appointment?.eligibility_status && (
                        <div className="chip-wrapper">
                          <p
                            className={'chip'}
                            style={{
                              backgroundColor:
                                EligibilityStatusMappingObj[
                                  appointment?.eligibility_status
                                ]?.borderColor ?? 'grey',
                              color:
                                EligibilityStatusMappingObj[
                                  appointment?.eligibility_status
                                ]?.color ?? 'white'
                            }}>
                            {EligibilityStatusMappingObj[
                              appointment?.eligibility_status
                            ]
                              ? t(
                                  EligibilityStatusMappingObj[
                                    appointment?.eligibility_status
                                  ].name
                                )
                              : appointment?.eligibility_status}
                          </p>
                          {eligibilityNetwork && (
                            <p
                              className={'chip'}
                              style={{
                                backgroundColor:
                                  (BenefitNetworkChipColor as any)[
                                    eligibilityNetwork
                                  ]?.backgroundColor || 'grey',
                                color:
                                  (BenefitNetworkChipColor as any)[
                                    eligibilityNetwork
                                  ]?.color || APP.COLOR.DEFAULT.WHITE
                              }}>
                              {t(
                                `ELIGIBILITY_VERIFICATION.${
                                  (networkKeyTranslationMapper as any)[
                                    eligibilityNetwork
                                  ]
                                }`
                              ) ?? eligibilityNetwork}
                            </p>
                          )}
                        </div>
                      )}
                  </div>
                }
              />
            </ListItem>
          );
        })}
      </List>
      {/* {ccmDialogOpen && (
        <CCMEnrollmentDialog
          open={ccmDialogOpen}
          onClose={async () => {
            closeCcmEnrollDialog();
            // update patient details
            dispatch(
              _setPatientDrawerPatientDetails(
                groupId,
                clinicId,
                selectedPatient?.patient_id
              )
            );
          }}
          patientName={patientFullName}
          accountNumber={selectedPatient.patient_account_number}
          patientId={selectedPatient.patient_id}
          groupId={groupId}
          clinicId={clinicId}
        />
      )} */}
      {ccmDialogOpen && (
        <CCMPatientProblemsDrawer
          open={ccmDialogOpen}
          closeDrawer={async () => {
            closeCcmEnrollDialog();
            dispatch(
              _setPatientDrawerPatientDetails(
                groupId,
                clinicId,
                selectedPatient?.patient_id
              )
            );
          }}
          ccmEnrolleData={stateShowDialog}
          // refreshMainGrid={resetPagesInGrid}
          patientName={patientFullName}
          accountNumber={selectedPatient.patient_account_number}
          patientId={selectedPatient.patient_id}
          clinicId={clinicId}
        />
      )}

      {/* This dialog for Add  CCM Time manually*/}
      {openAddCcmTimeDialog && (
        <AddCcmTimeDialog
          open={openAddCcmTimeDialog}
          onClose={() => closeCcmTimeDialog()}
          patientName={patientFullName}
          accountNumber={selectedPatient.patient_account_number}
          ccmPatientId={selectedPatient.ccm_patient_id}
          clinicId={clinicId}
          patientId={selectedPatient.patient_id}
        />
      )}
    </div>
  );
};
export default PatientDetailsSideBar;
